module.exports = __webpack_public_path__ + "img/preferably.aeda166e.png";